import React, { Component } from 'react';
class Banner extends Component {

    render() { 
        return (
            <React.Fragment>
            <header className="header">
                <div className="event-banner">
                    <div className="header-green-container"></div>
                    <div className="banner-text">
                        <div className="banner-tittle">
                            <h1 className="fuente-monserrat"> Acto de Grado Promoción XVII </h1>
                        </div>
                        <div className="banner-descrip">
                            <p align="justify" className="fuente-monserrat parrafo-grande">
                                El día 23 de Marzo de 2018, 137 graduandos de diferentes programas recibieron sus títulos en Acto de Grado realizado en el Auditorio del Colegio María Auxiliadora. Los nuevos graduados conforman la XVII Promoción que egresa de esta casa de estudios. ¡Felicitaciones!
                            </p>
                        </div>
                    </div>
                </div>
            </header>
            </React.Fragment>
        );
    }
}
 
export default Banner;


// WEBPACK FOOTER //
// ./src/site/Componentes/Eventos/Banner.jsx